<template>
  <div class="flight-editor-items responsive-menu">
    <div>
      <div class="flight-editor-items__row">
        <BaseBtn
          data-cy="edit-items-button"
          iconGroup="fas"
          iconName="plus"
          @click="() => (showSearchModal = !showSearchModal)"
          :disabled="!isEdit"
        />
        <div class="flight-editor-items__totals">
          <div class="flight-editor-items__totals--total">
            <div>Sub Total:</div>
            <div class="flight-totals-value">${{ subTotal }}</div>
          </div>
          <div class="flight-editor-items__totals--total">
            <div>Discount Total:</div>
            <div
              class="flight-totals-value"
              :class="{ 'flight-editor-items__error': discountTotal < 0 }"
            >
              ${{ discountTotal }}
            </div>
          </div>
          <div class="flight-editor-items__totals--total">
            <div>Total:</div>
            <div class="flight-totals-value">${{ lineTotal }}</div>
          </div>
        </div>
      </div>
      <div class="flight-editor-items__divider" />
      <div class="table-container">
        <table class="table-element">
          <thead>
            <tr class="header">
              <th
                v-for="header in columnHeaders"
                :key="`table-column-header-${header.id}-${header.title}`"
                class="header-cell"
              >
                {{ header.type === "button" ? "" : header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row"
              v-for="item in selectedFlight.items"
              :key="item._id"
            >
              <td class="cell">
                <BaseBtn
                  data-cy="delete-flight-item-button"
                  iconGroup="fas"
                  iconName="trash"
                  @click="() => removeProduct(item.product._id)"
                  :disabled="!isEdit"
                  :colorType="1"
                  class="flight-editor-items__delete-button"
                />
              </td>
              <td class="cell nav-cell"><span @click="() => navigateToProduct(item.product._id)">{{ getEntityValue(item, "product.name") }}</span></td>
              <td class="cell">
                {{ getEntityValue(item, "supplier.name") }}
              </td>
              <td class="cell" >
                {{ getEntityValue(item, "group.name") }}
              </td>
              <td class="cell">
                <BaseInput
                  v-if="isEdit"
                  controlType="number"
                  :isSmall="true"
                  v-model="item.quantity"
                  @input="formatFlight"
                />
                <template v-if="!isEdit">{{ item.quantity }}</template>
              </td>
              <td class="cell">${{ getEntityValue(item, "unitCost") }}</td>
              <td class="cell">${{ getEntityValue(item, "subTotal") }}</td>
              <td class="cell">${{ getEntityValue(item, "discount") }}</td>
              <td class="cell">${{ getEntityValue(item, "lineTotal") }}</td>
              <td class="cell">
                {{ getEntityValue(item, "product.cannabisGramsUnit") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <SearchModal
      v-if="showSearchModal"
      :showSearchModal="showSearchModal"
      @toggle-modal="toggleSearchModal"
      @select-item="selectProduct"
      :entity="Entities.PRODUCT"
      id="selectedItem"
      title="Select Products for Bundle"
      :forcedFilterCriteria="filterCriteria"
      :columnHeaders="searchColumnHeaders"
      :additionalFilters="additionalFilters"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

import BaseBtn from "@/components/Base/Button/Button.vue";
import BaseInput from "@/components/Base/Input/Base.vue";

import Constants from "@/resources/Constants";
import Utilities from "@/lib/Utilities";
import Entities from "@/resources/Entities";

import { columnHeaders, defaultSelectedItem } from "./inputs";
import { filterCriteria, searchColumnHeaders } from "../../../Product/inputs";

export default {
  name: "FlightItems",
  data() {
    return {
      Constants,
      moment,
      Utilities,
      flights: [],
      flightsResults: [],
      bus: new Vue(),
      isCollapsed: true,
      entity: Entities.FLIGHT,
      showSearchModal: false,
      columnHeaders,
      Entities,
      selectedItem: {},
      isEditTable: false,
      filterCriteria,
      searchColumnHeaders,
      defaultSelectedItem,
    };
  },
  props: {
    isEdit: Boolean,
  },
  components: {
    BaseBtn,
    BaseInput,
  },
  mounted: function () {},
  computed: {
    ...mapGetters({
      flight: "flightModule/flight",
      store: "storeModule/currentStore",
    }),
    selectedFlight: {
      get() {
        return this.calculateTotals(this.flight);
      },
      set(entity) {
        return this.calculateTotals(entity);
      },
    },
    discountTotal() {
      let sum = 0;
      if (this.flight.items?.length > 0)
        this.flight.items.forEach((item) => {
          sum += parseFloat(item.discount);
        });
      const result = Math.round(sum);
      this.$emit("discount-total", result);
      this.calculateGrams();
      return result;
    },
    lineTotal() {
      let sum = 0;
      if (this.flight.items?.length > 0)
        this.flight.items.forEach((item) => {
          sum += parseFloat(item.lineTotal);
        });
      return Math.round(sum);
    },
    subTotal() {
      let sum = 0;
      if (this.flight.items?.length > 0)
        this.flight.items.forEach((item) => {
          sum += parseFloat(item.subTotal || 0);
        });
      const result = Math.round(sum);
      this.$emit("sub-total", result);
      return result;
    },
    additionalFilters() {
      //active products
      return {
        isActive: true,
        isDeleted: false,
      };
    },
  },
  methods: {
    ...mapActions({
      getFlightById: "flightModule/getFlightById",
      getItemsByProductId: "itemModule/getItemsByProductId",
      setMessage: "setMessage",
    }),
    calculateGrams() {
      let sum = 0;
      if (this.flight.items?.length > 0)
        this.flight.items.forEach((item) => {
          sum += parseFloat(item.product?.cannabisGramsUnit || 0) * parseFloat(item.quantity || 0);
        });
      console.log("sum", sum);
      this.$emit("grams", sum);
      return sum;
    },
    toggleSearchModal: function () {
      this.showSearchModal = !this.showSearchModal;
    },
    editItemsTable: function () {
      this.isEditTable = !this.isEditTable;
    },
    calculateTotals: function (flight) {
      if (!flight?.items || flight?.items?.length === 0) return flight;
      let result = flight.items.map((item) => {
        let unitCost =
          flight.saleType === "medical"
            ? item?.product?.medicalPrice
            : item?.product?.recreationalPrice;
        const subTotal = parseFloat(unitCost || 0) * parseFloat(item.quantity || 1);
        return {
          ...item,
          subTotal: subTotal,
          unitCost: unitCost,
        };
      });

      // Sort products by unit cost (lowest to highest)
      result.sort((a, b) => parseFloat(a.unitCost || 0) - parseFloat(b.unitCost || 0));

      let sum = 0;
      result.forEach((item) => {
        sum += parseFloat(item.subTotal);
      });
      const discountPercentage = sum !== 0 ? flight.salePrice / sum : 0;

      result = result.map((item) => {
        return {
          ...item,
          discount: parseFloat(
            parseFloat(item.subTotal) -
              parseFloat(discountPercentage * item.subTotal)
          ).toFixed(2),
          lineTotal: parseFloat(discountPercentage * item.subTotal).toFixed(2),
        };
      });

      // Apply difference adjustment logic (ported from backend flightPricing.js)
      if (result.length > 0) {
        const calculatedTotal = result.reduce((acc, item) => acc + parseFloat(item.lineTotal), 0);
        const expectedTotal = parseFloat(flight.salePrice);
        const difference = parseFloat((calculatedTotal - expectedTotal).toFixed(2));

        if (difference !== 0) {
          const lastItem = result[result.length - 1];
          // Adjust the last item's lineTotal and discount to account for rounding differences
          lastItem.lineTotal = parseFloat((parseFloat(lastItem.lineTotal) - difference).toFixed(2));
          lastItem.discount = parseFloat((parseFloat(lastItem.subTotal) - parseFloat(lastItem.lineTotal)).toFixed(2));
        }
      }

      flight.items = result;
      return flight;
    },
    selectProduct: function (entity, product) {
      if (
        entity === "selectedItem" &&
        !this.selectedFlight.items.find((c) => c.item?._id === product._id)
      ) {
        const copiedObject = JSON.parse(JSON.stringify(defaultSelectedItem));
        const result = {
          ...copiedObject,
          supplier: product.supplier,
          product: product,
          group: product.group,
          grams: product.grams,
          unitCost: 0,
          subTotal: 0,
        };
        this.selectedFlight.items.unshift(result);
        this.selectedFlight = this.calculateTotals(this.selectedFlight);
        this.$emit("product-selected");
      }
    },
    getEntityValue: function (entity, id) {
      let result = _.get(entity, id);
      if (result === undefined || result === null) return "-";
      return result;
    },
    removeProduct: function (id) {
      const index = this.selectedFlight.items.findIndex(
        (c) => c.product?._id === id
      );
      if (index > -1) {
        this.selectedFlight.items.splice(index, 1);
        this.selectedFlight = this.calculateTotals(this.selectedFlight);
      }
    },
    formatFlight: function () {
      this.selectedFlight = this.calculateTotals(this.selectedFlight);
    },
    navigateToProduct: function (id) {
      window.open(`/products/productEditor?id=${id}`, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./_flight-items.scss";

.nav-cell {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
